import axios from 'axios'

import { AbacusMatrixProps } from '../lib/tag-manager'

const api = axios.create({
    baseURL: process.env.MATRIX_HOST,
    timeout: 10000,
    headers: {
        'Content-Type': 'application/json',
    },
})

api.interceptors.request.use(
    (config) => {
        console.log(`
    [REQUEST] => [${config.method}] ${config.baseURL}${config.url}
    headers: ${JSON.stringify(config.headers['Content-Type'])}
    body: ${JSON.stringify(config.data)}
  `)
        return config
    },
    (err) => {
        console.error(err)
    }
)

api.interceptors.response.use((response) => {
    console.log(`
    [RESPONSE] <= [${response.config.method}] ${response.config.baseURL}${response.config.url}
    headers: ${JSON.stringify(response.config.headers['Content-Type'])}
    data: ${JSON.stringify(response.data)}
  `)
    return response
})

export default {
    async sendData(payload: AbacusMatrixProps) {
        try {
            const result = await api.post('/v2/metric', payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
            })
            return result.data
        } catch (error) {
            console.error('[ERROR]', error)
        }
    },
}
